import { Humidor } from './humidor';
import { humiView } from './humidor_view';

export class cigaroUser{
  constructor(public id: number, public email: string,
    public language = 'auto', public theme: string,
    public humidors: Humidor[], public token: string,
    public sp_count: number, public humidor_view: humiView,
    public role: string, public currency: string) {
      if(typeof(humidor_view)==="undefined" || humidor_view===null){
        this.humidor_view={
          show_bd: false,
          show_brand: false,
          show_format: false,
          show_origin: false,
          show_metric:true,
          show_value:true,
          show_archive:true
        }
      }
  }

  /**
   *
   * @param humidorId
   * @returns Humidor mit bestimmter ID
   */
  getHumidor(humidorId:number):Humidor{
    let humiR:Humidor;
    humiR=null;
    this.humidors.forEach((humi)=>{
      if(humi.id===humidorId){
        humiR=humi;
      }
    });
    return humiR;
  }
}
